import { takeEvery, put, call, all, fork } from "redux-saga/effects";
import {
  CREATE_SALES_ORDER,
  POSTCODE_LOOKUP,
  GET_RENDER_ECOMMERCE_STORE,
  GET_PRODUCT_CATEGORIES,
  SEARCH_PRODUCTS_CATEGORY,
  CALCULATE_SHIPPING,
  CALCULATE_ORDER_TOTAL,
  EXECUTE_ECOMMERCE_STORE,
  GET_ECOMMERCE_DELIVERY_SLOTS,
} from "./actionType";
import {
  createSalesOrderSuccess,
  createSalesOrderFailure,
  postcodeLookupSuccess,
  postcodeLookupFailure,
  getRenderEcommerceStoreSuccess,
  getRenderEcommerceStoreFailure,
  getProductCategoriesSuccess,
  getProductCategoriesFailure,
  searchProductsByCategorySuccess,
  searchProductsByCategoryFailure,
  calculateShippingSuccess,
  calculateShippingFailure,
  calculateOrderTotalSuccess,
  calculateOrderTotalFailure,
  executeEcommerceStoreSuccess,
  executeEcommerceStoreFailure,
  getEcommerceDeliverySlotsSuccess,
  getEcommerceDeliverySlotsFailure,
} from "./action";
import {
  createSalesOrderApi,
  postcodeLookupApi,
  getRenderEcommerceStoreApi,
  getProductCategoriesApi,
  searchProductsByCategoryApi,
  calculateShippingApi,
  calculateOrderTotalApi,
  executeEcommerceStoreApi,
  getEcommerceDeliverySlotsApi,
} from "../../helpers/fakebackend_helper";

//CREATE_SALES_ORDER
function* createSalesOrder({ payload }) {
  try {
    const response = yield call(createSalesOrderApi, payload);
    yield put(createSalesOrderSuccess(response));
  } catch (error) {
    yield put(createSalesOrderFailure(error.message));
  }
}
function* watchCreateSalesOrder() {
  yield takeEvery(CREATE_SALES_ORDER, createSalesOrder);
}
//POSTCODE_LOOKUP
function* postcodeLookup({ payload }) {
  try {
    const response = yield call(postcodeLookupApi, payload);
    yield put(postcodeLookupSuccess(response));
  } catch (error) {
    yield put(postcodeLookupFailure(error.message));
  }
}
function* watchPostcodeLookup() {
  yield takeEvery(POSTCODE_LOOKUP, postcodeLookup);
}
//GET_RENDER_ECOMMERCE_STORE
function* getRenderEcommerceStore({ payload }) {
  try {
    const response = yield call(getRenderEcommerceStoreApi, payload);
    yield put(getRenderEcommerceStoreSuccess(response));
  } catch (error) {
    yield put(getRenderEcommerceStoreFailure(error.message));
  }
}
function* watchGetRenderEcommerceStore() {
  yield takeEvery(GET_RENDER_ECOMMERCE_STORE, getRenderEcommerceStore);
}
//GET_PRODUCT_CATEGORIES
function* getProductCategories({ payload }) {
  try {
    const response = yield call(getProductCategoriesApi, payload);
    yield put(getProductCategoriesSuccess(response));
  } catch (error) {
    yield put(getProductCategoriesFailure(error.message));
  }
}
function* watchGetProductCategories() {
  yield takeEvery(GET_PRODUCT_CATEGORIES, getProductCategories);
}
//SEARCH_PRODUCTS_CATEGORY
function* searchProductsByCategory({ payload }) {
  try {
    const response = yield call(searchProductsByCategoryApi, payload);
    yield put(searchProductsByCategorySuccess(response));
  } catch (error) {
    yield put(searchProductsByCategoryFailure(error.message));
  }
}
function* watchSearchProductsByCategory() {
  yield takeEvery(SEARCH_PRODUCTS_CATEGORY, searchProductsByCategory);
}
//CALCULATE_SHIPPING
function* calculateShipping({ payload, urlExtension }) {
  try {
    const response = yield call(calculateShippingApi, payload, urlExtension);
    yield put(calculateShippingSuccess(response));
  } catch (error) {
    yield put(calculateShippingFailure(error.message));
  }
}
function* watchCalculateShipping() {
  yield takeEvery(CALCULATE_SHIPPING, calculateShipping);
}
//CALCULATE_ORDER_TOTAL
function* calculateOrderTotal({ payload, urlExtension }) {
  try {
    const response = yield call(calculateOrderTotalApi, payload, urlExtension);
    yield put(calculateOrderTotalSuccess(response));
  } catch (error) {
    yield put(calculateOrderTotalFailure(error.message));
  }
}
function* watchCalculateOrderTotal() {
  yield takeEvery(CALCULATE_ORDER_TOTAL, calculateOrderTotal);
}
//EXECUTE_ECOMMERCE_STORE
function* executeEcommerceStore({ payload, urlExtension }) {
  try {
    const response = yield call(
      executeEcommerceStoreApi,
      payload,
      urlExtension
    );
    yield put(executeEcommerceStoreSuccess(response));
  } catch (error) {
    yield put(executeEcommerceStoreFailure(error.message));
  }
}
function* watchExecuteEcommerceStore() {
  yield takeEvery(EXECUTE_ECOMMERCE_STORE, executeEcommerceStore);
}
//GET_ECOMMERCE_DELIVERY_SLOTS
function* getEcommerceDeliverySlots({ payload }) {
  try {
    const response = yield call(getEcommerceDeliverySlotsApi, payload);
    yield put(getEcommerceDeliverySlotsSuccess(response));
  } catch (error) {
    yield put(getEcommerceDeliverySlotsFailure(error.message));
  }
}
function* watchGetEcommerceDeliverySlots() {
  yield takeEvery(GET_ECOMMERCE_DELIVERY_SLOTS, getEcommerceDeliverySlots);
}
//EXPORT THE SAGA
export default function* ecommerceSaga() {
  yield all([
    fork(watchCreateSalesOrder),
    fork(watchPostcodeLookup),
    fork(watchGetRenderEcommerceStore),
    fork(watchGetProductCategories),
    fork(watchSearchProductsByCategory),
    fork(watchCalculateShipping),
    fork(watchCalculateOrderTotal),
    fork(watchExecuteEcommerceStore),
    fork(watchGetEcommerceDeliverySlots),
  ]);
}
